import { useState } from "react";
import { sendTestPing } from "./trackVisit";

// Helper button to fire a test ping to Discord on demand.
// Gated behind REACT_APP_PING_DEBUG: shown only when it is exactly "true",
// hidden otherwise (including production).
export default function DevPingButton() {
  const [status, setStatus] = useState("idle"); // idle | sending | sent | failed

  if (process.env.REACT_APP_PING_DEBUG !== "true") return null;

  const labels = {
    idle: "Test Discord ping",
    sending: "Sending…",
    sent: "Ping sent ✓",
    failed: "Ping failed ✕",
  };

  const handleClick = async () => {
    if (status === "sending") return;
    setStatus("sending");
    const result = await sendTestPing();
    setStatus(result?.ok ? "sent" : "failed");
    setTimeout(() => setStatus("idle"), 2500);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fixed bottom-4 right-4 z-[60] px-4 py-2 rounded-full bg-accent text-white text-body-sm font-semibold shadow-card transition-all hover:bg-accent-hover hover:shadow-card-hover active:translate-y-px disabled:opacity-70"
      disabled={status === "sending"}
      title="Dev only — sends a test ping to your Discord webhook"
    >
      {labels[status]}
    </button>
  );
}
